class Tabs extends HTMLElement {
    constructor() {
        super();
        this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
        this._triggers = Array.from(this.querySelectorAll('[tab-trigger]'))
            .filter(el => el.closest('tabs-c') === this);
        this._contents = Array.from(this.querySelectorAll('[tab-content]'))
            .filter(el => el.closest('tabs-c') === this);

        this.addEventListener('click', this._onClick);

        const init = this._triggers.findIndex(t => t.classList.contains('active'));
        this._selectTab(init >= 0 ? init : 0);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
        const trigger = e.target.closest('[tab-trigger]');
        if (!trigger || trigger.closest('tabs-c') !== this) return;

        const idx = this._triggers.indexOf(trigger);
        if (idx >= 0) this._selectTab(idx);
    }

    _selectTab(idx) {
        this._triggers.forEach((t, i) =>
            t.classList.toggle('active', i === idx)
        );
        this._contents.forEach((c, i) =>
            c.classList.toggle('active', i === idx)
        );
        this.dispatchEvent(new CustomEvent('tab-change', {
            detail: { index: idx }
        }));
    }
}

customElements.define('tabs-c', Tabs);